/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const BusinessReportFilterMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the BusinessReportFilter interface.
 */
export function instanceOfBusinessReportFilter(value) {
    if (!('marketplace' in value) || value['marketplace'] === undefined)
        return false;
    return true;
}
export function BusinessReportFilterFromJSON(json) {
    return BusinessReportFilterFromJSONTyped(json, false);
}
export function BusinessReportFilterFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'],
        'missingFromReport': json['missingFromReport'] == null ? undefined : json['missingFromReport'],
        'unitsOrderedMin': json['unitsOrderedMin'] == null ? undefined : json['unitsOrderedMin'],
        'unitsOrderedMax': json['unitsOrderedMax'] == null ? undefined : json['unitsOrderedMax'],
        'orderedProductSalesMin': json['orderedProductSalesMin'] == null ? undefined : json['orderedProductSalesMin'],
        'orderedProductSalesMax': json['orderedProductSalesMax'] == null ? undefined : json['orderedProductSalesMax'],
        'totalOrderItemsMin': json['totalOrderItemsMin'] == null ? undefined : json['totalOrderItemsMin'],
        'totalOrderItemsMax': json['totalOrderItemsMax'] == null ? undefined : json['totalOrderItemsMax'],
        'sessionsMin': json['sessionsMin'] == null ? undefined : json['sessionsMin'],
        'sessionsMax': json['sessionsMax'] == null ? undefined : json['sessionsMax'],
        'pageViewsMin': json['pageViewsMin'] == null ? undefined : json['pageViewsMin'],
        'pageViewsMax': json['pageViewsMax'] == null ? undefined : json['pageViewsMax'],
        'browserSessionsMin': json['browserSessionsMin'] == null ? undefined : json['browserSessionsMin'],
        'browserSessionsMax': json['browserSessionsMax'] == null ? undefined : json['browserSessionsMax'],
        'mobileAppSessionsMin': json['mobileAppSessionsMin'] == null ? undefined : json['mobileAppSessionsMin'],
        'mobileAppSessionsMax': json['mobileAppSessionsMax'] == null ? undefined : json['mobileAppSessionsMax'],
        'browserPageViewsMin': json['browserPageViewsMin'] == null ? undefined : json['browserPageViewsMin'],
        'browserPageViewsMax': json['browserPageViewsMax'] == null ? undefined : json['browserPageViewsMax'],
        'mobileAppPageViewsMin': json['mobileAppPageViewsMin'] == null ? undefined : json['mobileAppPageViewsMin'],
        'mobileAppPageViewsMax': json['mobileAppPageViewsMax'] == null ? undefined : json['mobileAppPageViewsMax'],
        'buyBoxPercentageMin': json['buyBoxPercentageMin'] == null ? undefined : json['buyBoxPercentageMin'],
        'buyBoxPercentageMax': json['buyBoxPercentageMax'] == null ? undefined : json['buyBoxPercentageMax'],
        'unitSessionPercentageMin': json['unitSessionPercentageMin'] == null ? undefined : json['unitSessionPercentageMin'],
        'unitSessionPercentageMax': json['unitSessionPercentageMax'] == null ? undefined : json['unitSessionPercentageMax'],
        'sessionPercentageMin': json['sessionPercentageMin'] == null ? undefined : json['sessionPercentageMin'],
        'sessionPercentageMax': json['sessionPercentageMax'] == null ? undefined : json['sessionPercentageMax'],
        'pageViewsPercentageMin': json['pageViewsPercentageMin'] == null ? undefined : json['pageViewsPercentageMin'],
        'pageViewsPercentageMax': json['pageViewsPercentageMax'] == null ? undefined : json['pageViewsPercentageMax'],
        'browserSessionPercentageMin': json['browserSessionPercentageMin'] == null ? undefined : json['browserSessionPercentageMin'],
        'browserSessionPercentageMax': json['browserSessionPercentageMax'] == null ? undefined : json['browserSessionPercentageMax'],
        'mobileAppSessionPercentageMin': json['mobileAppSessionPercentageMin'] == null ? undefined : json['mobileAppSessionPercentageMin'],
        'mobileAppSessionPercentageMax': json['mobileAppSessionPercentageMax'] == null ? undefined : json['mobileAppSessionPercentageMax'],
        'browserPageViewsPercentageMin': json['browserPageViewsPercentageMin'] == null ? undefined : json['browserPageViewsPercentageMin'],
        'browserPageViewsPercentageMax': json['browserPageViewsPercentageMax'] == null ? undefined : json['browserPageViewsPercentageMax'],
        'mobileAppPageViewsPercentageMin': json['mobileAppPageViewsPercentageMin'] == null ? undefined : json['mobileAppPageViewsPercentageMin'],
        'mobileAppPageViewsPercentageMax': json['mobileAppPageViewsPercentageMax'] == null ? undefined : json['mobileAppPageViewsPercentageMax'],
        'unitsOrderedB2bMin': json['unitsOrderedB2bMin'] == null ? undefined : json['unitsOrderedB2bMin'],
        'unitsOrderedB2bMax': json['unitsOrderedB2bMax'] == null ? undefined : json['unitsOrderedB2bMax'],
        'orderedProductSalesB2bMin': json['orderedProductSalesB2bMin'] == null ? undefined : json['orderedProductSalesB2bMin'],
        'orderedProductSalesB2bMax': json['orderedProductSalesB2bMax'] == null ? undefined : json['orderedProductSalesB2bMax'],
        'totalOrderItemsB2bMin': json['totalOrderItemsB2bMin'] == null ? undefined : json['totalOrderItemsB2bMin'],
        'totalOrderItemsB2bMax': json['totalOrderItemsB2bMax'] == null ? undefined : json['totalOrderItemsB2bMax'],
        'sessionsB2bMin': json['sessionsB2bMin'] == null ? undefined : json['sessionsB2bMin'],
        'sessionsB2bMax': json['sessionsB2bMax'] == null ? undefined : json['sessionsB2bMax'],
        'pageViewsB2bMin': json['pageViewsB2bMin'] == null ? undefined : json['pageViewsB2bMin'],
        'pageViewsB2bMax': json['pageViewsB2bMax'] == null ? undefined : json['pageViewsB2bMax'],
        'browserSessionsB2bMin': json['browserSessionsB2bMin'] == null ? undefined : json['browserSessionsB2bMin'],
        'browserSessionsB2bMax': json['browserSessionsB2bMax'] == null ? undefined : json['browserSessionsB2bMax'],
        'mobileAppSessionsB2bMin': json['mobileAppSessionsB2bMin'] == null ? undefined : json['mobileAppSessionsB2bMin'],
        'mobileAppSessionsB2bMax': json['mobileAppSessionsB2bMax'] == null ? undefined : json['mobileAppSessionsB2bMax'],
        'browserPageViewsB2bMin': json['browserPageViewsB2bMin'] == null ? undefined : json['browserPageViewsB2bMin'],
        'browserPageViewsB2bMax': json['browserPageViewsB2bMax'] == null ? undefined : json['browserPageViewsB2bMax'],
        'mobileAppPageViewsB2bMin': json['mobileAppPageViewsB2bMin'] == null ? undefined : json['mobileAppPageViewsB2bMin'],
        'mobileAppPageViewsB2bMax': json['mobileAppPageViewsB2bMax'] == null ? undefined : json['mobileAppPageViewsB2bMax'],
        'buyBoxPercentageB2bMin': json['buyBoxPercentageB2bMin'] == null ? undefined : json['buyBoxPercentageB2bMin'],
        'buyBoxPercentageB2bMax': json['buyBoxPercentageB2bMax'] == null ? undefined : json['buyBoxPercentageB2bMax'],
        'unitSessionPercentageB2bMin': json['unitSessionPercentageB2bMin'] == null ? undefined : json['unitSessionPercentageB2bMin'],
        'unitSessionPercentageB2bMax': json['unitSessionPercentageB2bMax'] == null ? undefined : json['unitSessionPercentageB2bMax'],
        'sessionPercentageB2bMin': json['sessionPercentageB2bMin'] == null ? undefined : json['sessionPercentageB2bMin'],
        'sessionPercentageB2bMax': json['sessionPercentageB2bMax'] == null ? undefined : json['sessionPercentageB2bMax'],
        'pageViewsPercentageB2bMin': json['pageViewsPercentageB2bMin'] == null ? undefined : json['pageViewsPercentageB2bMin'],
        'pageViewsPercentageB2bMax': json['pageViewsPercentageB2bMax'] == null ? undefined : json['pageViewsPercentageB2bMax'],
        'browserSessionPercentageB2bMin': json['browserSessionPercentageB2bMin'] == null ? undefined : json['browserSessionPercentageB2bMin'],
        'browserSessionPercentageB2bMax': json['browserSessionPercentageB2bMax'] == null ? undefined : json['browserSessionPercentageB2bMax'],
        'mobileAppSessionPercentageB2bMin': json['mobileAppSessionPercentageB2bMin'] == null ? undefined : json['mobileAppSessionPercentageB2bMin'],
        'mobileAppSessionPercentageB2bMax': json['mobileAppSessionPercentageB2bMax'] == null ? undefined : json['mobileAppSessionPercentageB2bMax'],
        'browserPageViewsPercentageB2bMin': json['browserPageViewsPercentageB2bMin'] == null ? undefined : json['browserPageViewsPercentageB2bMin'],
        'browserPageViewsPercentageB2bMax': json['browserPageViewsPercentageB2bMax'] == null ? undefined : json['browserPageViewsPercentageB2bMax'],
        'mobileAppPageViewsPercentageB2bMin': json['mobileAppPageViewsPercentageB2bMin'] == null ? undefined : json['mobileAppPageViewsPercentageB2bMin'],
        'mobileAppPageViewsPercentageB2bMax': json['mobileAppPageViewsPercentageB2bMax'] == null ? undefined : json['mobileAppPageViewsPercentageB2bMax'],
    };
}
export function BusinessReportFilterToJSON(json) {
    return BusinessReportFilterToJSONTyped(json, false);
}
export function BusinessReportFilterToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'missingFromReport': value['missingFromReport'],
        'unitsOrderedMin': value['unitsOrderedMin'],
        'unitsOrderedMax': value['unitsOrderedMax'],
        'orderedProductSalesMin': value['orderedProductSalesMin'],
        'orderedProductSalesMax': value['orderedProductSalesMax'],
        'totalOrderItemsMin': value['totalOrderItemsMin'],
        'totalOrderItemsMax': value['totalOrderItemsMax'],
        'sessionsMin': value['sessionsMin'],
        'sessionsMax': value['sessionsMax'],
        'pageViewsMin': value['pageViewsMin'],
        'pageViewsMax': value['pageViewsMax'],
        'browserSessionsMin': value['browserSessionsMin'],
        'browserSessionsMax': value['browserSessionsMax'],
        'mobileAppSessionsMin': value['mobileAppSessionsMin'],
        'mobileAppSessionsMax': value['mobileAppSessionsMax'],
        'browserPageViewsMin': value['browserPageViewsMin'],
        'browserPageViewsMax': value['browserPageViewsMax'],
        'mobileAppPageViewsMin': value['mobileAppPageViewsMin'],
        'mobileAppPageViewsMax': value['mobileAppPageViewsMax'],
        'buyBoxPercentageMin': value['buyBoxPercentageMin'],
        'buyBoxPercentageMax': value['buyBoxPercentageMax'],
        'unitSessionPercentageMin': value['unitSessionPercentageMin'],
        'unitSessionPercentageMax': value['unitSessionPercentageMax'],
        'sessionPercentageMin': value['sessionPercentageMin'],
        'sessionPercentageMax': value['sessionPercentageMax'],
        'pageViewsPercentageMin': value['pageViewsPercentageMin'],
        'pageViewsPercentageMax': value['pageViewsPercentageMax'],
        'browserSessionPercentageMin': value['browserSessionPercentageMin'],
        'browserSessionPercentageMax': value['browserSessionPercentageMax'],
        'mobileAppSessionPercentageMin': value['mobileAppSessionPercentageMin'],
        'mobileAppSessionPercentageMax': value['mobileAppSessionPercentageMax'],
        'browserPageViewsPercentageMin': value['browserPageViewsPercentageMin'],
        'browserPageViewsPercentageMax': value['browserPageViewsPercentageMax'],
        'mobileAppPageViewsPercentageMin': value['mobileAppPageViewsPercentageMin'],
        'mobileAppPageViewsPercentageMax': value['mobileAppPageViewsPercentageMax'],
        'unitsOrderedB2bMin': value['unitsOrderedB2bMin'],
        'unitsOrderedB2bMax': value['unitsOrderedB2bMax'],
        'orderedProductSalesB2bMin': value['orderedProductSalesB2bMin'],
        'orderedProductSalesB2bMax': value['orderedProductSalesB2bMax'],
        'totalOrderItemsB2bMin': value['totalOrderItemsB2bMin'],
        'totalOrderItemsB2bMax': value['totalOrderItemsB2bMax'],
        'sessionsB2bMin': value['sessionsB2bMin'],
        'sessionsB2bMax': value['sessionsB2bMax'],
        'pageViewsB2bMin': value['pageViewsB2bMin'],
        'pageViewsB2bMax': value['pageViewsB2bMax'],
        'browserSessionsB2bMin': value['browserSessionsB2bMin'],
        'browserSessionsB2bMax': value['browserSessionsB2bMax'],
        'mobileAppSessionsB2bMin': value['mobileAppSessionsB2bMin'],
        'mobileAppSessionsB2bMax': value['mobileAppSessionsB2bMax'],
        'browserPageViewsB2bMin': value['browserPageViewsB2bMin'],
        'browserPageViewsB2bMax': value['browserPageViewsB2bMax'],
        'mobileAppPageViewsB2bMin': value['mobileAppPageViewsB2bMin'],
        'mobileAppPageViewsB2bMax': value['mobileAppPageViewsB2bMax'],
        'buyBoxPercentageB2bMin': value['buyBoxPercentageB2bMin'],
        'buyBoxPercentageB2bMax': value['buyBoxPercentageB2bMax'],
        'unitSessionPercentageB2bMin': value['unitSessionPercentageB2bMin'],
        'unitSessionPercentageB2bMax': value['unitSessionPercentageB2bMax'],
        'sessionPercentageB2bMin': value['sessionPercentageB2bMin'],
        'sessionPercentageB2bMax': value['sessionPercentageB2bMax'],
        'pageViewsPercentageB2bMin': value['pageViewsPercentageB2bMin'],
        'pageViewsPercentageB2bMax': value['pageViewsPercentageB2bMax'],
        'browserSessionPercentageB2bMin': value['browserSessionPercentageB2bMin'],
        'browserSessionPercentageB2bMax': value['browserSessionPercentageB2bMax'],
        'mobileAppSessionPercentageB2bMin': value['mobileAppSessionPercentageB2bMin'],
        'mobileAppSessionPercentageB2bMax': value['mobileAppSessionPercentageB2bMax'],
        'browserPageViewsPercentageB2bMin': value['browserPageViewsPercentageB2bMin'],
        'browserPageViewsPercentageB2bMax': value['browserPageViewsPercentageB2bMax'],
        'mobileAppPageViewsPercentageB2bMin': value['mobileAppPageViewsPercentageB2bMin'],
        'mobileAppPageViewsPercentageB2bMax': value['mobileAppPageViewsPercentageB2bMax'],
    };
}
